import {CssBaseline, ThemeProvider, ThemeProviderv2} from '@yandex-delivery/blocks'
import {I18nProvider} from '@yandex-delivery/core/i18n'
import Translate from '@yandex-delivery/core/i18n/translate'
import {ErrorBoundary, RumObservableRoot} from '@yandex-delivery/modules/rum'
import {TariffsConfigProvider} from '@yandex-delivery/modules/tariffs-v3'
import {Tariffs} from '@yandex-delivery/modules/tariffs-v3/desktop'
import React from 'react'
import {BrowserRouter as Router, Route} from 'react-router-dom'

import {Application} from './application'
import {config} from './config'
import {tariffsConfig} from './tariffsConfig'

const t = Translate(config.config.lang, config.i18n)

export default function AppV3() {
  return (
    <Application>
      <ThemeProviderv2 dir={config.config.dir} locale={config.config.lang}>
        <ThemeProvider>
          <ErrorBoundary i18n={t}>
            <CssBaseline />
            <I18nProvider t={t}>
              <RumObservableRoot>
                <TariffsConfigProvider config={tariffsConfig}>
                  <Router basename={config.config.basename}>
                    <Route path="/:country?/:city?/:tariff?">
                      <Tariffs withHeader />
                    </Route>
                  </Router>
                </TariffsConfigProvider>
              </RumObservableRoot>
            </I18nProvider>
          </ErrorBoundary>
        </ThemeProvider>
      </ThemeProviderv2>
    </Application>
  )
}
